import useAuth from "../auth";

import useNavigation from "../navigation"

const useRouterHelper = () => {
  const { getSession } = useAuth();
  const { authToken } = getSession;
  const { navigateTo } = useNavigation();

  const requireAuth = () => {
    // Simple token check - no API call needed
    // NavBar's actRefreshPermissions() handles session validation
    // Interceptor handles 401 errors globally and redirects to "/"
    if (!authToken) {
      return navigateTo("/")
    }
  };

  return {
    requireAuth
  }
};

export default useRouterHelper;